import React from 'react'
import Layout from '../../Layout/Layout'
import market1 from '../../images/market1.PNG'

import market2 from '../../images/market2.PNG'

import { Link } from "react-router-dom";


const Market_Access = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div>
                <h2 className='light uk-text-bold uk-margin-xlarge-top'>Market Access</h2>
                
                <h3 className='light uk-text-bold '>SEADE Soft-landing Market Access Program</h3>
                
                </div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The SEADE (Strengthening the European-African Digital Ecosystem)
                         Soft-landing Market Access Program is a strategic twinning initiative that
                          successfully created a crucial innovation bridge between the Nigerian and 
                          Portuguese startup ecosystems. Funded by the European Union and implemented by
                           Moolu Venture Lab in partnership with IPN Portugal, the program's primary 
                           objective was to facilitate cross-border Research & Innovation cooperation
</p>

                <p className='light'>By selecting high-potential startups from both regions, the program
                     focused on preparing them for successful market entry into a new continent, 
                     effectively strengthening the overall Africa-EU digital ecosystem.</p>

                     <p className='light'>The program's methodology involved a structured approach,
                         starting with a rigorous cohort selection followed by intensive market 
                         validation and ecosystem linkages. Nigerian startups gained critical insights
                        and validation for expanding into the European market (Portugal), while 
                        Portuguese startups explored access to the vast Nigerian market. Key milestones
                        achieved included customized mentorship that addressed specific regulatory,
                        cultural, and scaling challenges, along with the development of strategic
                        partnerships and potential collaborations in high-growth sectors like FinTech,
                        AgriTech, and Clean Energy.</p>
               </div>

                <div className='uk-width-1-2@s'>
                    <img src={market1} />
               </div>
            </div>




               <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                        <img src={market2} />
               </div>

                <div className='uk-width-1-2@s'>

                <p className='light'>The SEADE (Strengthening the European-African Digital Ecosystem)
                         Soft-landing Market Access Program is a strategic twinning initiative that
                          successfully created a crucial innovation bridge between the Nigerian and 
                          Portuguese startup ecosystems. Funded by the European Union and implemented by
                           Moolu Venture Lab in partnership with IPN Portugal, the program's primary 
                           objective was to facilitate cross-border Research & Innovation cooperation
</p>

                <p className='light'>By selecting high-potential startups from both regions, the program
                     focused on preparing them for successful market entry into a new continent, 
                     effectively strengthening the overall Africa-EU digital ecosystem.</p>


                  
               </div>
            </div>


            <div className='uk-grid'>
              <div className='uk-width-3-4@s'>
                 <p className='light'>Overall, the SEADE Twinning Program laid a robust foundation for
                    sustainable Africa-EU ecosystem growth and the long-term scalability
                    of the participating ventures. Its success in fostering direct
                    collaboration between African and European innovation hubs serves as
                     a replicable framework for future twinning programs designed to unlock
                      global growth opportunities. The program demonstrates the power of 
                      strategic international partnerships in empowering startups, 
                      facilitating market access, and ultimately accelerating cross-continental
                       trade and investment pathways.</p>
              </div>

               <div className='uk-width-1-4@s'>

              </div>
            </div>
        </div>
        </Layout>
  )
}

export default Market_Access